import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CaseService } from '../../services/case.service';
import { UtilitiesService } from '../../services/utilities.service';
import { DictionaryService } from '../../services/dictionary.service';
import { ApplicationValueDto } from './dto/application-value.dto';
import { ApplicationPropertyDto } from '../case/dto/application-property.dto';

import { DatePipe } from '@angular/common';
import { MessageService, Message } from 'primeng/api';
import * as theGlobals from 'src/app/shared/globals';


@Component({
  selector: 'app-case-value',
  templateUrl: './case-value.component.html'
})
export class CaseValueComponent implements OnInit {

  @Input() caseId: string;
  @Input() myProp: ApplicationPropertyDto;
  @Output() changeEvent = new EventEmitter();

  myValueAssessor: any; // ApplicationValueDto;
  myValueApplicant: any; // ApplicationValueDto;
  myValueOpinion: any; // ApplicationValueDto;
  myValueFinal: any; // ApplicationValueDto;
  myValueTotals: any; // contains Totals, Difference, etc (i.e. calculated fields)
  myValueCase: any; // contains Roll Type, etc..
  myEmitObject: any; // composite object containing ALL values, totals, roll type, etc

  rollYear: string;
  valuesCount = 0;  // counter; used to display Values data ONLY when we've retrieved all the values; should eliminate undef errors - rod
  isNewCase = false; // if this is a NEW case
  rollYearList: [];
  assessTypes: [];

  allowAssessorValues: boolean;

  constructor(private caseService: CaseService, private utilService: UtilitiesService, private dictService: DictionaryService,
              private messageService: MessageService, private datePipe: DatePipe) { }

  createNewValues() {
    this.myValueAssessor = new ApplicationValueDto().create();
    this.myValueApplicant = new ApplicationValueDto().create();
    this.myValueOpinion = new ApplicationValueDto().create();
    this.myValueFinal = new ApplicationValueDto().create();
  }

  ngOnInit(): void {
    this.valuesCount = 0;
    const dicts = this.dictService.getDictionaries(); // get all dictionaries
    this.utilService.doAudit(dicts, 'dictionaries');
    this.rollYearList = dicts.rollYearChoices;
    this.assessTypes = dicts.assessTypes;

    this.myValueTotals = {
      totalValue: 0,
      valueDifference: 0
    };
    this.myValueCase = {
      assessType: ''
    };
    this.rollYear = '';
    this.isNewCase = false;

    this.allowAssessorValues = theGlobals.allowAssessorValues;
    //
    if (!this.caseId) {
      // new case; no data to retrieve
      this.createNewValues();
      this.isNewCase = true;
      return;
    }
    let myTotal: any;
    let mySubTotal: any;
    // get ALL values at once - implemented 5/17/2022 rod
    this.caseService.getAllValues(this.caseId).subscribe(allData => {
      this.utilService.doAudit(allData, 'all values:');
      this.myValueApplicant = allData[0]; // applicant values
      this.myValueOpinion = allData[1];   // opinion values
      this.myValueAssessor = allData[2];  // assessor values
      this.myValueFinal = allData[3]; // final values
      // set up total/sub-total
      myTotal = this.myValueAssessor.totalValue;
      mySubTotal = this.myValueAssessor.netValue;
      if (!myTotal) {
        this.myValueAssessor.totalValue = this.utilService.stripCommas(this.calcTotalByType(3), false);
        this.myValueAssessor.netValue = this.utilService.stripCommas(this.calcSubTotalByType(3), false);
      } else {
        this.myValueAssessor.totalValue = this.utilService.stripCommas(myTotal, false);
        this.myValueAssessor.netValue = this.utilService.stripCommas(mySubTotal, false);
      }
      myTotal = this.myValueFinal.totalValue;
      mySubTotal = this.myValueFinal.netValue;
      if (!myTotal) {
        this.myValueFinal.totalValue = this.utilService.stripCommas(this.calcTotalByType(4), false);
        this.myValueFinal.netValue = this.utilService.stripCommas(this.calcSubTotalByType(4), false);
      }
      else {
        this.myValueFinal.totalValue = this.utilService.stripCommas(myTotal, false);
        this.myValueFinal.netValue = this.utilService.stripCommas(mySubTotal , false);
      }
      //
      this.formatTemplateValues([1, 11, 21, 31, 41, 51, 61, 71, 81]);
      this.valuesCount = ++this.valuesCount;
      this.formatTemplateValues([2, 12, 22, 32, 42, 52, 62, 72, 82]);
      this.valuesCount = ++this.valuesCount;
      this.formatTemplateValues([3, 13, 23, 33, 43, 53, 63, 73, 83]);
      this.valuesCount = ++this.valuesCount;
      this.formatTemplateValues([4, 14, 24, 34, 44, 54, 64, 74, 84]);
      this.valuesCount = ++this.valuesCount;
      this.valueChanged(1000);  // force an emit event, so the parent component can capture this set of Values
    });
    // get Roll Type; getValueCase
    this.caseService.getValueCase(this.caseId).subscribe(data => {
      // {"applicationId":7209,"assessType":"Supplemental","valueDifference":500000.00,"totalValue":1500000.00}
      // console.log(data);
      if (data) {
        this.myValueCase = data;
        if (!data.assessType) {
          this.myValueCase.assessType = '';
        }
      } else {
        this.myValueCase = {
          assessType: ''
        };
      }
      this.valuesCount = ++this.valuesCount;
      this.valueChanged(1000);  // force an emit event, so the parent component can capture this set of Values
    });
    // get Roll Year from Property record
    this.caseService.getCaseProperty(this.caseId).subscribe(data => {
      this.utilService.doAudit(data, 'Prop for getting year:');
      this.rollYear = data.rollYear;
    });

  }

  // format the values - this is run from ngOnInit (i.e. when we get the initial data)
  formatTemplateValues(mySource: number[]) {
    this.utilService.doAudit(mySource, 'about to format these values:');
    for (let i = 0; i < mySource.length; i++) {
      this.addCommas(mySource[i], false);
    }
  }
  //
  valueChanged(myNum: number) {
    if (myNum == 0) {
      this.utilService.doAudit(this.myValueFinal, 'final data:');
      return;
    }
    this.utilService.doAudit(myNum, 'Value was changed:');
    this.updateEmitObject();   // create composite object
    this.changeEvent.emit(this.myEmitObject); // transmit ALL values
    this.utilService.doAudit(this.myEmitObject, 'emitted composite object:');
  }

  // update composite Values object, for trasmission to Parent component (via event emitter)
  updateEmitObject() {
    this.myEmitObject = {
      valueAssessor: this.myValueAssessor,
      valueApplicant: this.myValueApplicant,
      valueOpinion: this.myValueOpinion,
      valueFinal: this.myValueFinal,
      caseInfo: this.myValueCase,
      rollYear: this.rollYear,
      valueTotal: this.myValueTotals
    };
  }

  addCommas(myNum: number, fromTemplate: boolean = true) {
    // user has left the input element...
    // calculate the totals, but only if the change initiated w/ the user coz on the call from ngOnInit, some of the objects won't be present...
    // if (fromTemplate) { this.calculateTotalValue(); }
    this.calculateTotalValue();
    // replace with calcTotalByType (to limit what totals are affected)??
    // let totType = Math.trunc(myNum / 10);
    // this.calcTotalByType(totType);
    //
    // add the commas to the field we just left...
    let myVal: any;
    const myCateg = Math.trunc(myNum / 10);
    const mySource = +myNum % 10;
    if (myCateg == 0) { // Land Values
      if (mySource == 1) {
        myVal = this.myValueApplicant.landValue;
        this.myValueApplicant.landValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.landValue;
        this.myValueOpinion.landValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.landValue;
        this.myValueAssessor.landValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.landValue;
        this.myValueFinal.landValue = this.utilService.thouSeparator(myVal);
      }
    } else if (myCateg == 1) {  // improvements
      if (mySource == 1) {
        myVal = this.myValueApplicant.improveValue;
        this.myValueApplicant.improveValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.improveValue;
        this.myValueOpinion.improveValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.improveValue;
        this.myValueAssessor.improveValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.improveValue;
        this.myValueFinal.improveValue = this.utilService.thouSeparator(myVal);
      }
    } else if (myCateg == 2) {  // fixtures
      if (mySource == 1) {
        myVal = this.myValueApplicant.fixturesValue;
        this.myValueApplicant.fixturesValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.fixturesValue;
        this.myValueOpinion.fixturesValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.fixturesValue;
        this.myValueAssessor.fixturesValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.fixturesValue;
        this.myValueFinal.fixturesValue = this.utilService.thouSeparator(myVal);
      }
    } else if (myCateg == 3) {  // personal property
      if (mySource == 1) {
        myVal = this.myValueApplicant.personalValue;
        this.myValueApplicant.personalValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.personalValue;
        this.myValueOpinion.personalValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.personalValue;
        this.myValueAssessor.personalValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.personalValue;
        this.myValueFinal.personalValue = this.utilService.thouSeparator(myVal);
      }
    } else if (myCateg == 4) {  // mineral rights
      if (mySource == 1) {
        myVal = this.myValueApplicant.mineralValue;
        this.myValueApplicant.mineralValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.mineralValue;
        this.myValueOpinion.mineralValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.mineralValue;
        this.myValueAssessor.mineralValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.mineralValue;
        this.myValueFinal.mineralValue = this.utilService.thouSeparator(myVal);
      }
    } else if (myCateg == 5) {  // trees and vines
      if (mySource == 1) {
        myVal = this.myValueApplicant.treesValue;
        this.myValueApplicant.treesValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.treesValue;
        this.myValueOpinion.treesValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.treesValue;
        this.myValueAssessor.treesValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.treesValue;
        this.myValueFinal.treesValue = this.utilService.thouSeparator(myVal);
      }
    } else if (myCateg == 6) {  // exemptions
      if (mySource == 1) {
        myVal = this.myValueApplicant.exemptValue;
        this.myValueApplicant.exemptValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.exemptValue;
        this.myValueOpinion.exemptValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.exemptValue;
        this.myValueAssessor.exemptValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.exemptValue;
        this.myValueFinal.exemptValue = this.utilService.thouSeparator(myVal);
      }
    } else if (myCateg == 7) {  // penalties
      if (mySource == 1) {
        myVal = this.myValueApplicant.penaltyValue;
        this.myValueApplicant.penaltyValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.penaltyValue;
        this.myValueOpinion.penaltyValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.penaltyValue;
        this.myValueAssessor.penaltyValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.penaltyValue;
        this.myValueFinal.penaltyValue = this.utilService.thouSeparator(myVal);
      }
    } else if (myCateg == 8) {  // net totals
      if (mySource == 1) {
        myVal = this.myValueApplicant.netValue;
        this.myValueApplicant.netValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 2) {
        myVal = this.myValueOpinion.netValue;
        this.myValueOpinion.netValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 3) {
        myVal = this.myValueAssessor.netValue;
        this.myValueAssessor.netValue = this.utilService.thouSeparator(myVal);
      } else if (mySource == 4) {
        myVal = this.myValueFinal.netValue;
        this.myValueFinal.netValue = this.utilService.thouSeparator(myVal);
      }
    }

    // if the change was initiated by user interaction in template, emit the change to the parent
    if (fromTemplate) { this.valueChanged(myNum); }
  }

  removeCommas(myNum: number) {
    // when user is doing input, we remove commas
    this.utilService.doAudit(myNum, 'removing commas for:');
    const myCateg = Math.trunc(myNum / 10);
    const mySource = +myNum % 10;
    if (myCateg === 0) {  // land values
      if (mySource == 1) {
        this.myValueApplicant.landValue = this.utilService.stripCommas(this.myValueApplicant.landValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.landValue = this.utilService.stripCommas(this.myValueOpinion.landValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.landValue = this.utilService.stripCommas(this.myValueAssessor.landValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.landValue = this.utilService.stripCommas(this.myValueFinal.landValue, false);
      }
    } else if (myCateg == 1) {  // improvements
      if (mySource == 1) {
        this.myValueApplicant.improveValue = this.utilService.stripCommas(this.myValueApplicant.improveValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.improveValue = this.utilService.stripCommas(this.myValueOpinion.improveValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.improveValue = this.utilService.stripCommas(this.myValueAssessor.improveValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.improveValue = this.utilService.stripCommas(this.myValueFinal.improveValue, false);
      }
    } else if (myCateg == 2) {  // fixtures
      if (mySource == 1) {
        this.myValueApplicant.fixturesValue = this.utilService.stripCommas(this.myValueApplicant.fixturesValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.fixturesValue = this.utilService.stripCommas(this.myValueOpinion.fixturesValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.fixturesValue = this.utilService.stripCommas(this.myValueAssessor.fixturesValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.fixturesValue = this.utilService.stripCommas(this.myValueFinal.fixturesValue, false);
      }
    } else if (myCateg == 3) {  // personal property
      if (mySource == 1) {
        this.myValueApplicant.personalValue = this.utilService.stripCommas(this.myValueApplicant.personalValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.personalValue = this.utilService.stripCommas(this.myValueOpinion.personalValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.personalValue = this.utilService.stripCommas(this.myValueAssessor.personalValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.personalValue = this.utilService.stripCommas(this.myValueFinal.personalValue, false);
      }
    } else if (myCateg == 4) {  // mineral rights
      if (mySource == 1) {
        this.myValueApplicant.mineralValue = this.utilService.stripCommas(this.myValueApplicant.mineralValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.mineralValue = this.utilService.stripCommas(this.myValueOpinion.mineralValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.mineralValue = this.utilService.stripCommas(this.myValueAssessor.mineralValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.mineralValue = this.utilService.stripCommas(this.myValueFinal.mineralValue, false);
      }
    } else if (myCateg == 5) {  // trees and vines
      if (mySource == 1) {
        this.myValueApplicant.treesValue = this.utilService.stripCommas(this.myValueApplicant.treesValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.treesValue = this.utilService.stripCommas(this.myValueOpinion.treesValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.treesValue = this.utilService.stripCommas(this.myValueAssessor.treesValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.treesValue = this.utilService.stripCommas(this.myValueFinal.treesValue, false);
      }
    } else if (myCateg == 6) {  // exemptions
      if (mySource == 1) {
        this.myValueApplicant.exemptValue = this.utilService.stripCommas(this.myValueApplicant.exemptValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.exemptValue = this.utilService.stripCommas(this.myValueOpinion.exemptValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.exemptValue = this.utilService.stripCommas(this.myValueAssessor.exemptValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.exemptValue = this.utilService.stripCommas(this.myValueFinal.exemptValue, false);
      }
    } else if (myCateg == 7) {  // penalties
      if (mySource == 1) {
        this.myValueApplicant.penaltyValue = this.utilService.stripCommas(this.myValueApplicant.penaltyValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.penaltyValue = this.utilService.stripCommas(this.myValueOpinion.penaltyValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.penaltyValue = this.utilService.stripCommas(this.myValueAssessor.penaltyValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.penaltyValue = this.utilService.stripCommas(this.myValueFinal.penaltyValue, false);
      }
    } else if (myCateg == 8) {  // net totals
      if (mySource == 1) {
        this.myValueApplicant.netValue = this.utilService.stripCommas(this.myValueApplicant.netValue, false);
      } else if (mySource == 2) {
        this.myValueOpinion.netValue = this.utilService.stripCommas(this.myValueOpinion.netValue, false);
      } else if (mySource == 3) {
        this.myValueAssessor.netValue = this.utilService.stripCommas(this.myValueAssessor.netValue, false);
      } else if (mySource == 4) {
        this.myValueFinal.netValue = this.utilService.stripCommas(this.myValueFinal.netValue, false);
      }
    }
  }

  //
  calculateTotalValue() {
    // for CaseValue table
    const applicantTotalVal = this.utilService.stripCommas(this.calcTotalByType(1));
    const opinionTotalVal = this.utilService.stripCommas(this.calcTotalByType(2));
    const assessorTotalVal = this.utilService.stripCommas(this.calcTotalByType(3));
    const finalTotalVal = this.utilService.stripCommas(this.calcTotalByType(4));
    let opinionVal = 0;
    // First insert totals into individual groups
    this.myValueApplicant.totalValue = applicantTotalVal;
    this.myValueOpinion.totalValue = opinionTotalVal;
    this.myValueAssessor.totalValue = assessorTotalVal;
    this.myValueFinal.totalValue = finalTotalVal;

    // now get grand total and difference
    this.myValueTotals.totalValue = 0;
    if (assessorTotalVal) {
        this.myValueTotals.totalValue = assessorTotalVal;
    } else if (applicantTotalVal){
        this.myValueTotals.totalValue = applicantTotalVal;
    }

    if (opinionTotalVal) {
        opinionVal = opinionTotalVal;
    }
    this.myValueTotals.valueDifference = +this.myValueTotals.totalValue - opinionVal;
  }

  calcTotalByType(myType: number) {
    let myTotal = 0;
    if (myType == 1) {
      myTotal = this.utilService.stripCommas(this.myValueApplicant.landValue) + this.utilService.stripCommas(this.myValueApplicant.improveValue) + this.utilService.stripCommas(this.myValueApplicant.fixturesValue) + this.utilService.stripCommas(this.myValueApplicant.mineralValue) + this.utilService.stripCommas(this.myValueApplicant.treesValue) + this.utilService.stripCommas(this.myValueApplicant.personalValue);
    } else if (myType == 2) {
      myTotal = this.utilService.stripCommas(this.myValueOpinion.landValue) + this.utilService.stripCommas(this.myValueOpinion.improveValue) + this.utilService.stripCommas(this.myValueOpinion.fixturesValue) + this.utilService.stripCommas(this.myValueOpinion.mineralValue) + this.utilService.stripCommas(this.myValueOpinion.treesValue) + this.utilService.stripCommas(this.myValueOpinion.personalValue);
    } else if (myType == 3) {
      myTotal = this.utilService.stripCommas(this.myValueAssessor.landValue) + this.utilService.stripCommas(this.myValueAssessor.improveValue) + this.utilService.stripCommas(this.myValueAssessor.fixturesValue) + this.utilService.stripCommas(this.myValueAssessor.mineralValue) + this.utilService.stripCommas(this.myValueAssessor.treesValue) + this.utilService.stripCommas(this.myValueAssessor.personalValue);
    } else if (myType == 4) {
      myTotal = this.utilService.stripCommas(this.myValueFinal.landValue) + this.utilService.stripCommas(this.myValueFinal.improveValue) + this.utilService.stripCommas(this.myValueFinal.fixturesValue) + this.utilService.stripCommas(this.myValueFinal.mineralValue) + this.utilService.stripCommas(this.myValueFinal.treesValue) + this.utilService.stripCommas(this.myValueFinal.personalValue);
    } else if (myType == 5) {
      // applicant penalties
      myTotal = this.utilService.stripCommas(this.myValueApplicant.penaltyValue) + this.utilService.stripCommas(this.myValueApplicant.exemptValue);
    }
    return myTotal;
  }
  calcSubTotalByType(myType: number) {
    let myTotal = 0;
    if (myType == 1) {
      myTotal = this.utilService.stripCommas(this.myValueApplicant.totalValue) - this.utilService.stripCommas(this.myValueApplicant.exemptValue) + this.utilService.stripCommas(this.myValueApplicant.penaltyValue);
    } else if (myType == 2) {
      myTotal = this.utilService.stripCommas(this.myValueOpinion.totalValue) - this.utilService.stripCommas(this.myValueOpinion.exemptValue) + this.utilService.stripCommas(this.myValueOpinion.penaltyValue);
    } else if (myType == 3) {
      myTotal = this.utilService.stripCommas(this.myValueAssessor.totalValue) - this.utilService.stripCommas(this.myValueAssessor.exemptValue) + this.utilService.stripCommas(this.myValueAssessor.penaltyValue);
    } else if (myType == 4) {
      myTotal = this.utilService.stripCommas(this.myValueFinal.totalValue) - this.utilService.stripCommas(this.myValueFinal.exemptValue) + this.utilService.stripCommas(this.myValueFinal.penaltyValue);
    } else if (myType == 5) {
      // applicant penalties
      myTotal = this.utilService.stripCommas(this.myValueApplicant.penaltyValue) - this.utilService.stripCommas(this.myValueApplicant.exemptValue);
    }
    return myTotal;
  }

  disableGetSecure() {
    if (this.myProp.apn && this.rollYear) {
      return false;
    }
    return true;
  }
  disableGetUnsecure(): boolean {
    if (this.myProp.unsecuredNum && this.rollYear) {
      return false;
    }
    return true;
  }
  getUnsecureValues() {
    this.utilService.doAudit(this.myProp, 'MyProp:');
    let apn = this.myProp.unsecuredNum;
    let xApn = apn.replace(/\s|-/g,'');  // strip out the dashes
    let apnType = apn.slice(0,1);  // extract first char
    let rollYear = this.rollYear;
    const curYear = new Date().getFullYear();
    let exemptAmt = 0;
    let personalProp = 0;
    //
    this.utilService.doAudit(apn + '/' + rollYear, 'APN/Year:');
    if (rollYear) {
      let temp = rollYear.split('/');
      rollYear = Number(temp[0]).toString();
    } else {
      rollYear = curYear.toString();
    }
    this.caseService.getUnsecuredValues(xApn, rollYear).subscribe(data => {
      this.utilService.doAudit(data, 'Unsecured values:');
      if (data.length > 0) {

        if (apnType === '3' || apnType === '4' ) {
          this.myValueAssessor.mineralValue = data[0].land;
        }
        else {
          this.myValueAssessor.landValue = data[0].land;
        }
        this.myValueAssessor.improveValue = data[0].improvements;
        this.myValueAssessor.fixturesValue = data[0].tradeFixture;
        this.myValueAssessor.treesValue = data[0].livingImp;
        this.myValueAssessor.penaltyValue = data[0].penalty;
        // calculate personal property; personal prop + boat + aircraft - rod 12/2024
        personalProp = data[0].personalProperty;
        if (data[0].boat) { personalProp = personalProp + data[0].boat; }
        if (data[0].aircraft) { personalProp = personalProp + data[0].aircraft; }
        this.myValueAssessor.personalValue = personalProp;
        //
        // calculate total exempt amount
        if (data[0].inventoryExempt) {exemptAmt = exemptAmt + data[0].inventoryExempt;}
        if (data[0].homeOwnerExempt) {exemptAmt = exemptAmt + data[0].homeOwnerExempt;}
        if (data[0].otherExempt) {exemptAmt = exemptAmt + data[0].otherExempt;}
        if (data[0].veteranExempt) {exemptAmt = exemptAmt + data[0].veteranExempt;}
        this.myValueAssessor.exemptValue = exemptAmt;
        // calculate total/sub-total
        this.myValueAssessor.totalValue = this.utilService.stripCommas(this.calcTotalByType(3), false);
        this.myValueAssessor.netValue = this.utilService.stripCommas(this.calcSubTotalByType(3), false);
        // format all the fields
        this.formatTemplateValues([3, 13, 23, 33, 43, 53, 63, 73, 83]);
        // force an emit event, so the parent component can capture this set of Values
        this.valueChanged(1000);
      } else {
        this.showToast({ key: 'toast', severity: 'info', detail: 'No data found for Unsecured #: ' + apn, summary: 'Info' });
      }
    });
  }
  getSecureValues()
  {
    this.utilService.doAudit(this.myProp, 'MyProp:');
    let apn = this.myProp.apn;
    let xApn = apn.replace(/\s|-/g,'');  // strip out the dashes
    apn = apn.replace(/\s/g,'-');  // replace spaces with dashes, for consistent format
    let rollYear = this.rollYear;
    const curYear = new Date().getFullYear();
    let apnType = '';
    let ppVal = 0;
    let exemptAmt = 0;
    //
    this.utilService.doAudit(apn + '/' + rollYear, 'APN/Year:');
    if (rollYear) {
      let temp = rollYear.split('/');
      rollYear = Number(temp[0]).toString();
    } else {
      rollYear = curYear.toString();
    }
    apnType = apn.slice(0,1);  // extract first char
    this.utilService.doAudit(apnType, 'APN Type:');
    this.caseService.findAPN(xApn, rollYear).subscribe(data => {
      this.utilService.doAudit(data,'result from findAPN:');
      if (data.length > 0) {
        if (apnType === '3' || apnType === '4' ) {
          this.myValueAssessor.mineralValue = data[0].land;
        }
        else {
          this.myValueAssessor.landValue = data[0].land;
        }
        this.myValueAssessor.improveValue = data[0].structImp;
        this.myValueAssessor.fixturesValue = data[0].tradeFixture;
        this.myValueAssessor.treesValue = data[0].livingImp;
        //
        if (data[0].ppDeclared) {ppVal = ppVal + data[0].ppDeclared;}
        if (data[0].ppUnitValue) {ppVal = ppVal + data[0].ppUnitValue;}
        if (data[0].ppMobileHome) {ppVal = ppVal + data[0].ppMobileHome;}
        this.myValueAssessor.personalValue = ppVal;
        //
        if (data[0].ttLothXmpAmt) {exemptAmt = exemptAmt + data[0].ttLothXmpAmt;}
        if (data[0].ttLhOxmpAmt) {exemptAmt = exemptAmt + data[0].ttLhOxmpAmt;}
        this.myValueAssessor.exemptValue = exemptAmt;
        // calculate total/sub-total
        this.myValueAssessor.totalValue = this.utilService.stripCommas(this.calcTotalByType(3), false);
        this.myValueAssessor.netValue = this.utilService.stripCommas(this.calcSubTotalByType(3), false);
        // format all the fields
        this.formatTemplateValues([3, 13, 23, 33, 43, 53, 63, 73, 83]);
        // force an emit event, so the parent component can capture this set of Values
        this.valueChanged(1000);
      } else {
        this.showToast({ key: 'toast', severity: 'info', detail: 'No data found for APN: ' + apn, summary: 'Info' });
      }
    });
    /*
    const match = this.caseService.findAPNOLD(apn);
    this.utilService.doAudit(match, 'match:');
    if (match) {
      this.myValueAssessor.landValue = match.land;
      this.addCommas(3, true);
      this.myValueAssessor.improveValue = match.structImp;
      this.addCommas(13, true);
      this.myValueAssessor.fixturesValue = match.tradeFixture;
      this.addCommas(23);
    } else {
      this.showToast({ key: 'toast', severity: 'info', detail: 'No data found for APN: ' + apn, summary: 'Info' });
    }
     */
  }

    // Toaster/Message-related methods
    showToast(msg: Message) {
      this.messageService.clear('toast');
      this.messageService.add(msg);
    }

    showInfo(myMsg: Message) {
      this.messageService.clear('info');
      this.messageService.add(myMsg);
    }

    clearAll() {
      this.messageService.clear();
    }

    // DEPRECATED methods
    OLDngOnInit() {
      this.valuesCount = 0;
      const dicts = this.dictService.getDictionaries(); // get all dictionaries
      this.utilService.doAudit(dicts, 'dictionaries');
      this.rollYearList = dicts.rollYearChoices;
      this.assessTypes = dicts.assessTypes;

      this.myValueTotals = {
        totalValue: 0,
        valueDifference: 0
      };
      this.myValueCase = {
        assessType: ''
      };
      this.rollYear = '';
      this.isNewCase = false;

      this.allowAssessorValues = theGlobals.allowAssessorValues;
      //
      if (!this.caseId) {
        // new case; no data to retrieve
        this.createNewValues();
        this.isNewCase = true;
        return;
      }
      let myTotal: any;
      let xAllVals: any;
      this.caseService.getAllValues(this.caseId).subscribe(allData => {
        this.utilService.doAudit(allData, 'all values:');
      });
      // get data for various value "groups", property, etc
      this.caseService.getValueGroup(this.caseId, 'applicant').subscribe(data => {
        this.myValueApplicant = data;
        this.formatTemplateValues([1, 11, 21, 31, 41, 51, 61, 71, 81]);
        this.valuesCount = ++this.valuesCount;
        this.valueChanged(1000);  // force an emit event, so the parent component can capture this set of Values
      });
      this.caseService.getValueGroup(this.caseId, 'opinion').subscribe(data => {
        this.myValueOpinion = data;
        this.formatTemplateValues([2, 12, 22, 32, 42, 52, 62, 72, 82]);
        this.valuesCount = ++this.valuesCount;
        this.valueChanged(1000);  // force an emit event, so the parent component can capture this set of Values
      });
      this.caseService.getValueGroup(this.caseId, 'assessor').subscribe(data => {
        // this.utilService.doAudit(data, 'response for Value Group Assessor:');
        this.myValueAssessor = data;
        this.formatTemplateValues([3, 13, 23, 33, 43, 53, 63, 73, 83]);
        myTotal = this.myValueAssessor.totalValue;
        if (!myTotal) {
          this.myValueAssessor.totalValue = this.utilService.stripCommas(this.calcTotalByType(3), false);
        } else {
          this.myValueAssessor.totalValue = this.utilService.stripCommas(myTotal, false);
        }
        this.valuesCount = ++this.valuesCount;
        this.valueChanged(1000);  // force an emit event, so the parent component can capture this set of Values
      });
      this.caseService.getValueGroup(this.caseId, 'final').subscribe(data => {
        this.myValueFinal = data;
        this.formatTemplateValues([4, 14, 24, 34, 44, 54, 64, 74, 84]);
        myTotal = this.myValueFinal.totalValue;
        if (!myTotal) {
          this.myValueFinal.totalValue = this.utilService.stripCommas(this.calcTotalByType(4), false);
        }
        else {
          this.myValueFinal.totalValue = this.utilService.stripCommas(myTotal, false);
        }
        this.valuesCount = ++this.valuesCount;
        this.valueChanged(1000);  // force an emit event, so the parent component can capture this set of Values
      });
      // get Roll Type; getValueCase
      this.caseService.getValueCase(this.caseId).subscribe(data => {
        // {"applicationId":7209,"assessType":"Supplemental","valueDifference":500000.00,"totalValue":1500000.00}
        if (data) {
          this.myValueCase = data;
          if (!data.assessType) {
            this.myValueCase.assessType = '';
          }
        } else {
          this.myValueCase = {
            assessType: ''
          };
        }
        this.valuesCount = ++this.valuesCount;
        this.valueChanged(1000);  // force an emit event, so the parent component can capture this set of Values
      });
      // get Roll Year from Property record
      this.caseService.getCaseProperty(this.caseId).subscribe(data => {
        this.rollYear = data.rollYear;
      });
    }
}
